/** Angular */
import { Injectable } from '@angular/core';

@Injectable()
export class TypesUtilsService {
    /**
     * Convert number to string and addinng '0' before
     *
     * @param value: number
     */
    padNumber(value: number) {
        if (this.isNumber(value)) {
            return `0${value}`.slice(-2);
        } else {
            return '';
        }
    }

    /**
     * Checking value type equals to Number
     *
     * @param value: any
     */
    isNumber(value: any): boolean {
        return !isNaN(this.toInteger(value));
    }

    /**
     * Covert value to number
     *
     * @param value: any
     */
    toInteger(value: any): number {
        return parseInt(`${value}`, 10);
    }

    /**
     * Convert date to string with 'MM/dd/yyyy' format
     *
     * @param date: Date
     */
    dateFormat(date: Date): string {
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        if (date) {
            return `${month}/${day}/${year}`;
        }

        return '';
    }

    /**
     * Returns a string with the date in the format required
     * by backend
     * @param date date object
     * @param pattern string which match with some of the cases
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-01-15
     */
    dateCustomFormat(date: Date, pattern?: string): string {
        if (date) {
            const year = date.getFullYear();
            const month = (1 + date.getMonth()).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            if (pattern && pattern === 'YYYY/MM/dd') {
                return year + '/' + month + '/' + day;
            }
			if (pattern && pattern === 'YYYY-MM-dd') {
                return year + '-' + month + '-' + day;
            }
            if (pattern && pattern === 'MM/dd/YYYY') {
                return year + '/' + month + '/' + day;
            }
             if (pattern && pattern === 'dd-mm-yyyy') {
                return day + '-' + month + '-' + year;
            }
            return day + '/' + month + '/' + year;
        }

        return '';
    }

    

    /**
     * Convert string to DateFormatter (For Reactive Forms Validators)
     *
     * @param dateInStr: string (format => 'MM/dd/yyyy')
     */
    getDateFormatterFromString(dateInStr: string): any {
        if (dateInStr && dateInStr.length > 0) {
            const dateParts = dateInStr.trim().split('/');
            return [
                {
                    year: this.toInteger(dateParts[2]),
                    month: this.toInteger(dateParts[0]),
                    day: this.toInteger(dateParts[1])
                }
            ];
        }

        const _date = new Date();
        return [
            {
                year: _date.getFullYear(),
                month: _date.getMonth() + 1,
                day: _date.getDay()
            }
        ];
    }

    /**
     * Convert string to Date
     *
     * @param dateInStr: string (format => 'MM/dd/yyyy')
     */
    getDateFromString(dateInStr: string = ''): Date {
        if (dateInStr && dateInStr.length > 0) {
            const dateParts = dateInStr.trim().split('/');
            const year = this.toInteger(dateParts[2]);
            const month = this.toInteger(dateParts[0]);
            const day = this.toInteger(dateParts[1]);
            // tslint:disable-next-line:prefer-const
            let result = new Date();
            result.setDate(day);
            result.setMonth(month - 1);
            result.setFullYear(year);
            return result;
        }

        return new Date();
    }


    /**
     * Convert Date to string with format 'MM/dd/yyyy'
     * @param _date: Date?
     */
    getDateStringFromDate(_date: Date = new Date()): string {
        const month = _date.getMonth() + 1;
        const year = _date.getFullYear();
        const date = _date.getDate();
        return `${month}/${date}/${year}`;
    }

    /**
     * Generates an array of size N starting from position 0 to N-1
     * @param n length of the array
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-12-16
     */
    genArrayOfSizeN(n: number) {
        const arrayOfColumnNumbers = [];
        for (let i = 0; i < n; i++) {
            arrayOfColumnNumbers.push(i);
        }
        return arrayOfColumnNumbers;
    }
}
